/*
    Rest configuration to link the tool with The mongo DB backend.
*/
import { buildRestGetCoreFromUrl } from "../synchronizationApi";
import { API_BASE_URL } from "../constants";
import * as UTIL from "../utilities";

export const urlCore = API_BASE_URL;
export const CRM = "crm";
export const FINANCE = "finance";

export const getUrlPath = syncGroup => {
  //TODO: Check on the domain.
  if (syncGroup === "SYNC_GROUP_FINANCE") {
    return FINANCE;
  }
  return CRM;
};

export const buildRestGetCore = (syncGroup, synchronizations) => {
  var urlPath = getUrlPath(syncGroup);
  const url = urlCore + urlPath;
  return buildRestGetCoreFromUrl(url, synchronizations);
};

export const updateSyncObjectAndHeadersCore = (
  syncObject,
  headers,
  objectConfig,
  response
) => {
  console.log("Nothing todo here");
};

export const updateSyncObjectAndHeadersForGetCore = (
  syncObject,
  headers,
  objectConfig,
  response
) => {
  console.log("Nothing todo here");
};

export const buildRestUpdateCore = (object, objectConfig) => {
  if (UTIL.isEmpty(object)) {
    console.log("object is empty");
    return;
  }
  //Beter to encapsulate this.
  var newObject = {};
  var body = {};
  var method = "post";
  var urlPath = getUrlPath(objectConfig);
  objectConfig.fieldsConfig.forEach(field => {
    if (
      field.backendField !== null &&
      field.backendField !== undefined &&
      field.backendField !== "" &&
      object[field.field] !== undefined &&
      object[field.field] !== null &&
      field.edit !== false
    ) {
      newObject[field.backendField] = object[field.field];
    }
  });

  body = {
    objectConfig: objectConfig.objectConfig,
    id: object.Guid,
    update: newObject,
    reqId: UTIL.getGuid()
  };

  return {
    body: body,
    method: method,
    url: urlCore + urlPath
  };
};
